export const GEMINI_API_KEY = 'AQ.Ab8RN6KIS8I5lkipGTG55vqG7zXrJGZCHBeEbwffm8De8_ceKQ';
